
// import link02 from "../assets/oms.png"
// import link03 from "../assets/logoArmed.svg"
// import link04 from "../assets/pnud.png"
// import link05 from "../assets/cnp.svg"


interface ImageDataLinks {
    id: number;
    src: string;
    url: string
}

// export const imageDataLinks: ImageDataLinks[]  = [
//   { id: 1, src: link02 , url: "https://www.who.int/pt1"},
//   { id: 2, src: link04, url: "https://www.pnud.org/pt/angola"},
//   { id: 4, src: link05, url: "https://www.cnp.ao"},
//   { id: 3, src: link03, url: "https://www.armed.gov.ao"},
// ];


const pages = [
    { 'page': 'Início', 'link': '/' },
    { 'page': 'Sobre Nós', 'link': '/sobre-nos' },
    { 'page': 'Legislação e Documentos', 'link': '/legislacao-e-documentos' },
    { 'page': 'Contactos', 'link': '/contactos' },
];

export const navegacaoBar = [

    {
        'page': 'Início', 'link': '/', 'menuItens': []
    },

    {
        'page': 'Sobre Nós', 'menuItens':
            [
                { 'page': 'Missão, Visão e Valores', 'link': '/informacoes?menu=SOBRE NÓS&opcao=MISSÃ VISÃO VALORES' },
                { 'page': 'Organigrama', 'link': '/informacoes?menu=SOBRE NÓS&opcao=ORGANIGRAMA' },
                { 'page': 'Serviços Locias', 'link': '/informacoes?menu=SOBRE NÓS&opcao=Serviços Locais' },
                { 'page': 'Inspectores', 'link': '/inspectores' },
            ],
    },
    {
        'page': 'Serviços', 'menuItens':
            [
                { 'page': 'Licenciamento de Estabelecimento Farmacêutico', 'link': '/agenda-disponivel' },
                { 'page': 'Renovação de Autorização de exercicio Farmacêutico', 'link': '/solicitacao-de-renovacao-de-estabelecimento' },
                { 'page': 'Importação e Exportação', 'link': '/importacao-e-exportacao' },
                { 'page': 'Certificado de Produtos Controlados', 'link': '/inspeccao-regulatoria/solicitacao/certificado-produto-controlado/Produtos%20Controlados' },
                { 'page': 'Desalfandegamento', 'link': '/solicitacao-de-desalfandegamento' },
                { 'page': 'Controlo de Qualidade', 'link': '/opcoes/controlo-de-qualidade' },
                { 'page': 'Farmacovigilancia e Ensaios Clinicos', 'link': '/farmacovigilancia-forlumarios' },
            ]
    },
    {
        'page': 'Legislação e Documentos', 'menuItens':
            [
                // { 'page': 'Decretos', 'link': '/decretos' },
                { 'page': 'Alertas', 'link': '/informacoes?menu=FARMACOVIGILÂNCIA&tipoFile=Alerta' },
                { 'page': 'Decretos', 'link': '/informacoes?menu=LEGISLACÃO E DOCUMENTOS&tipoFile=Decreto' },
                { 'page': 'Despachos', 'link': '/informacoes?menu=LEGISLACÃO E DOCUMENTOS&tipoFile=Despacho' },
                { 'page': 'Leis', 'link': '/informacoes?menu=LEGISLACÃO E DOCUMENTOS&tipoFile=Lei' },
                { 'page': 'Circulares', 'link': '/informacoes?menu=LEGISLACÃO E DOCUMENTOS&tipoFile=Circular' },
                { 'page': 'Taxas e Emolumentos', 'link': '/taxas-e-emolumentos' },
                { 'page': 'Boas Praticas Regulatorias', 'link': '/informacoes?menu=LEGISLACÃO E DOCUMENTOS&tipoFile=Boas Praticas Regulatoria' },
                { 'page': 'Farmacovigilancia e Ensaios Clinicos', 'link': '/farmacovigilancia ' }, ///informacoes?menu=LEGISLACÃO E DOCUMENTOS&tipoFile=Decreto
                { 'page': 'Medicamentos Aprovados', 'link': '/informacoes?menu=MEDICAMENTOS&opcao=Medicamento Aprovado' },
                { 'page': 'Outros', 'link': '/informacoes?menu=LEGISLACÃO E DOCUMENTOS&tipoFile=Outros' },
            ]
    },

    {
        'page': 'Contactos', 'link': '/contactos', 'menuItens': []
    }
];
